import ResponsiveAppBar from "../components/navbar/Navbar";
import ArchiveMain from "./Archive/Archive";
import Home from "./home/Home";
import Profile from "./profile/Profile";
import LogIn from "./register/LogIn";
import SignUp from "./register/SignUp";

export default function ResponsiveLogin() {
    return(
        <ResponsiveAppBar page={<LogIn/>}/>
    )
}

export function ResponsiveSignUp() {
    return(
        <ResponsiveAppBar page={<SignUp/>}/>
    )
}
export function ResponsiveHome() {
    return(
        <ResponsiveAppBar page={<Home/>}/>
    )
}
export function ResponsiveProfile() {
    return(
        <ResponsiveAppBar page={<Profile/>}/>
    )
}
export function ResponsiveArchive() {
    return(
        <ResponsiveAppBar page={<ArchiveMain/>}/>
    )
}